/**
 * Detecta si el flujo actual es "Vida Activa" leyendo
 * localStorage.summary.data y buscando un item con
 * label === "producto" y value === "vida activa" (ambos en lowercase).
 *
 * Reemplaza el flag de GrowthBook `afy-validate-only-credit-card`
 * para esta detección.
 */
export var isVidaActiva = function () {
    try {
        var stored = localStorage.getItem("summary");
        if (!stored)
            return false;
        var parsed = JSON.parse(stored);
        var items = Array.isArray(parsed === null || parsed === void 0 ? void 0 : parsed.data)
            ? parsed.data
            : [];
        return items.some(function (item) {
            var _a, _b;
            return ((_a = item === null || item === void 0 ? void 0 : item.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "producto" &&
                ((_b = item === null || item === void 0 ? void 0 : item.value) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "vida activa";
        });
    }
    catch (_a) {
        return false;
    }
};
